/* 🤖 this file was generated by svg-to-ts*/
export const icoMail: {
  name: 'mail';
  data: string;
} = {
  name: 'mail',
  data: `<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3335 0.333374C13.0699 0.333374 13.6668 0.930328 13.6668 1.66671V8.33337C13.6668 9.06975 13.0699 9.66671 12.3335 9.66671H1.66683C0.93045 9.66671 0.333496 9.06975 0.333496 8.33337V1.66671C0.333496 0.930328 0.93045 0.333374 1.66683 0.333374H12.3335ZM12.3335 2.55204L7.43916 6.83509C7.20875 7.0367 6.87419 7.0535 6.62643 6.88549L6.56115 6.83509L1.66683 2.55271V8.33337H12.3335V2.55204ZM11.3202 1.66671H2.6795L7.00015 5.44737L11.3202 1.66671Z" fill="#0BEBE9"/>
    </svg>
    `
};
